<template>
  <div>
    <customModal
      v-if="modalData"
      v-show="modalData"
      :onModalClose="onModalClose"
      :onModalAccept="setBackPack"
      :modalData="modalData"
    ></customModal>

    <table class="table table-hover table-sm">
      <thead>
      <tr>
        <th>ID</th>
        <th></th>
        <th>Имя</th>
        <th v-if="useBackPacks">Рюкзак</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="(runner, index) in runners"
        :key="index"
        v-if="Number(index)"
      >
        <td>{{ index }}</td>
        <td>
          <input
            v-model="selected_runner"
            :value="index"
            name="runner_radio"
            type="radio"
            :id="'r_' + index"
          />
        </td>
        <td>
          <label class="pointer" :for="'r_' + index">
            {{ runner }}
            <span
              v-if="runnerOrders && runnerOrders[index] && runnerOrders[index].length"
            >
                        ({{ runnerOrders[index].length }})
                      </span>
          </label>
          <i
            v-if="runnerOrders && runnerOrders[index] && runnerOrders[index].length"
            @click="goTo(index)"
            class="icon-fa icon-fa-hand-o-down"
          ></i>
        </td>
        <td class="text-right" v-if="useBackPacks">
          <div class="backpack" v-if="backPacks && backPacks[index]">
            <span class="w_backpack">с рюкзаком</span>
          </div>
          <div
            class="backpack"
            v-if="
                                  backPacks && !backPacks[index] &&
                                  runnerOrders &&
                                    runnerOrders[index] &&
                                    runnerOrders[index].length
                               ">
            <button @click="modalBackPack(index)" class="btn btn-success btn-xs">выдать</button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import customModal from "@/components/modals/customModal";
import api from "@/api";

export default {
  components: {
    customModal,
  },
  props: ['useBackPacks', 'backPacks', 'runners', 'goToRunnerBlock', 'runnerOrders', 'updateSelectedRunner'],
  data() {
    return {
      modalData: null,
      selected_runner: null,
    }
  },
  watch: {
    selected_runner() {
      if (this.updateSelectedRunner) {
        this.updateSelectedRunner(this.selected_runner);
      }
    }
  },
  methods: {
    goTo(index) {
      // let element = this.$refs["runner_table_" + index];
      // if (Array.isArray(element)) {
      //   element = element[0];
      // }
      // this.showRunnerOrders[index] = true;
      // // element.scrollIntoView(true);
      // window.scrollTo(0, element.getBoundingClientRect().top - 70);
    },
    async setBackPack() {
      let {data} = await api.store("/runners/setBackpack", {
        runner_id: this.modalData.runnerId
      });
      if (data.success) {
        this.backPacks[this.modalData.runnerId] = true;
        this.Toast.fire({
          type: "success",
          title: "Сохранено"
        });
      } else {
        this.Toast.fire({
          type: "warning",
          title: "Ошибка " + data.message
        });
      }
      this.modalData = null;
    },
    onModalClose() {
      this.modalData = null;
    },
    modalBackPack(runnerId) {
      // console.log(runnerId);
      this.modalData = {
        runnerId: runnerId,
        header: "Вы уверены?",
        body: "Хотите выдать рюкзак<br><b>" + this.runners[runnerId] + "</b>?",
        acceptBtnText: "Да",
        cancelBtnText: "Нет"
      };
    },
  }
}

</script>

<style scoped>
.table td,
.table th {
  padding: 2px 10px;
}
</style>
